import React from "react";
import { Loading, Modal } from "seed/helpers";
import l from "components/util/l";
import RoleFormCreate from "components/presentation/sections/settings/roles/RoleFormCreate";
import RoleFormEdit from "components/presentation/sections/settings/roles/RoleFormEdit";


const RolesView = ({
  flow,
  roles,
  activeEditingRole,
  onlyAdminRoles,
  isCreateModalShown,
  isEditModalShown,
  isLoading,
  reqRoles,
  onClickDeleteRole,
  onClickOpenCreateModal,
  onCloseCreateModal,
  onClickOpenEditModal,
  onCloseEditModal,
}) => (
  <>
    <div className="card w-100 h-100">
      <div className="card-header">
        <h3 className="card-header-title">
          {l("Personalizar roles%PA072")}
        </h3>
      </div>

      <div className="card-body px-6 py-4 overflow-auto">
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary" onClick={onClickOpenCreateModal}>
            <i class="fas fa-plus mr-1"></i> {l("Agregar rol%PA073")}
          </button>
        </div>

        <table className="table table-striped table-hover mt-3">
          <thead>
            <tr>
              <th>{l("Nombre%GA074")}</th>
              <th className="text-right w-25">{l("Acciones%GA005")}</th>
            </tr>
          </thead>

          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="2" className="text-center">
                  <Loading />
                </td>
              </tr>
            ) : roles.length === 0 ? (
              <tr>
                <td colSpan="2" className="text-center">
                  {l("No hay roles personalizados%PA074")}
                </td>
              </tr>
            ) : roles.map((role, idx) => (
              <tr key={idx}>
                <td>{role?.name}</td>
                <td className="text-right">
                  <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => onClickOpenEditModal(role.id)}>
                    <i class="fas fa-pen"></i>
                  </button>
                  <button type="button" className="btn btn-sm btn-outline-primary ml-2" onClick={() => onClickDeleteRole(role.id)}>
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </div>

    {isCreateModalShown ? (
      <Modal
        width="500"
        height="500"
        flowId={flow.id}
        onlyAdminRoles={onlyAdminRoles}
        onClose={onCloseCreateModal}
        reqRoles={reqRoles}
        component={RoleFormCreate}
      />
    ) : null}

    {isEditModalShown && activeEditingRole ? (
      <Modal
        width="500"
        height="500"
        roleId={activeEditingRole}
        flowId={flow.id}
        onClose={onCloseEditModal}
        reqRoles={reqRoles}
        component={RoleFormEdit}
      />
    ) : null}

  </>
)

export default RolesView;